import React, { useState } from "react";
import { LendsTable } from "../../components/table/lendsTable";
import useGetLends from "../../services/useGetLends";
import { usePagination } from "../../services/usePagination";

export const AvailableToLend = ({
  setGlobalOfferModalOpen,
  selectedCollections,
}: {
  setGlobalOfferModalOpen: any;
  selectedCollections: any[];
}) => {
  const [searchText, setSearchText] = useState("");
  const {
    data: lends,
    isLoading,
    totalCount,
    totalPages,
    page,
    reset,
    changePage,
  } = usePagination({
    useFetch: useGetLends,
    defaultLimit: 10,
    defaultPage: 0,
    listed: true,
    search: searchText,
    collectionAddresses: selectedCollections.map((c) => c.address),
  });

  const onSearchClick = async (e: any) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    setSearchText(formData.get("search").toString());
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <h2 className="font-display text-jacarta-700 py-4 text-2xl font-medium dark:text-white">
            Available To Lend
          </h2>
        </div>

        <div>
          <button
            onClick={() => setGlobalOfferModalOpen(true)}
            className="bg-accent w-full inline-flex justify-center shadow-accent-volume hover:bg-accent-dark rounded-full py-2 px-3 text-center font-semibold text-white transition-all"
          >
            Global Offer
          </button>
        </div>
      </div>
      <div style={{ height: 1000, width: "100%", overflowX: "auto" }}>
        <LendsTable
          rows={lends}
          totalPages={totalPages}
          totalCount={totalCount}
          currentPage={page}
          setCurrentPage={changePage}
          loading={isLoading}
          onSearchClick={onSearchClick}
          setSearchText={setSearchText}
          searchText={searchText}
          pageSize={10}
        />
      </div>
    </div>
  );
};
